import { render, staticRenderFns } from "./invoice4.vue?vue&type=template&id=37bd9e54&scoped=true"
import script from "./invoice4.vue?vue&type=script&lang=js"
export * from "./invoice4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bd9e54",
  null
  
)

export default component.exports